import RunningTotal from 'components/runningtotal/running-total';
import React from 'react';
import BuildingControls from './building-controls';

export interface BuildingSidebarProps {}

const BuildingSidebar: React.FunctionComponent<BuildingSidebarProps> = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background: Theme['@grey-lightest'],
        // padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <BuildingControls />
      <div>
        <RunningTotal />
      </div>
    </div>
  );
};

export default BuildingSidebar;
